module.exports = __webpack_public_path__ + "img/226-united-states.f4cc0b5e.svg";